import { useEffect, useState } from 'react';

// Tema interfeței: Deschis / Închis / Automat (după setarea sistemului). Se păstrează în browser.
export type ThemeChoice = 'light' | 'dark' | 'system';
const KEY = 'moro.theme';
const media = typeof window !== 'undefined' ? window.matchMedia('(prefers-color-scheme: dark)') : null;

export function getThemeChoice(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'light' || v === 'dark' || v === 'system') return v;
  } catch { /* ignorat */ }
  return 'light';
}

function effective(choice: ThemeChoice): 'light' | 'dark' {
  return choice === 'system' ? (media?.matches ? 'dark' : 'light') : choice;
}

export function applyTheme(choice = getThemeChoice()) {
  const t = effective(choice);
  document.documentElement.dataset.theme = t;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', t === 'dark' ? '#08111c' : '#083050');
}

const listeners = new Set<(c: ThemeChoice) => void>();
export function setThemeChoice(choice: ThemeChoice) {
  try { localStorage.setItem(KEY, choice); } catch { /* ignorat */ }
  applyTheme(choice);
  listeners.forEach((l) => l(choice));
}

media?.addEventListener('change', () => { if (getThemeChoice() === 'system') applyTheme('system'); });

export function useTheme(): [ThemeChoice, (c: ThemeChoice) => void, 'light' | 'dark'] {
  const [choice, setChoice] = useState(getThemeChoice);
  useEffect(() => {
    listeners.add(setChoice);
    return () => { listeners.delete(setChoice); };
  }, []);
  return [choice, setThemeChoice, effective(choice)];
}
